import { RedeemSettingsInput } from "../../../graphql/types";

// GraphQL result objects can include __typename; mutation inputs cannot.
export function toRedeemSettingsInput(settings: RedeemSettingsInput): RedeemSettingsInput {
  const how = settings.howToRedeem;
  return {
    whereToRedeem: settings.whereToRedeem,
    howToRedeem: how == null ? how : {
      code: how.code,
      websiteToEnterCodeAt: how.websiteToEnterCodeAt,
      contactEmail: how.contactEmail,
      contactNumber: how.contactNumber,
      contactName: how.contactName,
    },
  };
}
